import { Button, Center, Stack, Text } from '@chakra-ui/react'
import React, { ErrorInfo, ReactNode } from 'react'
import useStore from '../store/useStore'
import { stopImpersonation } from '../utils/impersonationService'

interface State {
  error?: Error
}

class Boundary extends React.Component<
  { children: ReactNode; isImpersonating: boolean },
  State
> {
  state: State = {}

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Application route failed', error, info)
    }
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <Center as='main' flex='1'>
        <Stack align='center'>
          <Text>That page could not be displayed.</Text>
          {this.props.isImpersonating && (
            <Button
              colorScheme='orange'
              onClick={() => void stopImpersonation('error')}
            >
              Stop Impersonation
            </Button>
          )}
        </Stack>
      </Center>
    )
  }
}

const ImpersonationErrorBoundary = ({ children }: { children: ReactNode }) => {
  const isImpersonating = useStore(
    (state) => state.identityStatus === 'impersonating',
  )
  return (
    <Boundary isImpersonating={isImpersonating}>{children}</Boundary>
  )
}

export default ImpersonationErrorBoundary
